import { useState } from "react";
import useWexClient from "./Clients/wexClient,";

const useShifts = () => {
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState(null);

  const {
    addShifts,
    getShifts,
    shiftScheduling,
    updateShifts: updateShiftsApi,
  } = useWexClient();

  const handleRequest = async (callback, defaultMessage) => {
    setLoader(true);
    setError(null);

    try {
      const response = await callback();

      return response;
    } catch (err) {
      console.error(defaultMessage, err);

      const errorMessage =
        err?.response?.data?.message || err?.message || defaultMessage;

      setError(errorMessage);

      return {
        success: false,
        message: errorMessage,
        data: null,
      };
    } finally {
      setLoader(false);
    }
  };

  /**
   * Crear turno
   */
  const createNewShift = async (body = {}) => {
    return handleRequest(() => addShifts(body), "Error al crear turno");
  };

  /**
   * Obtener turnos
   */
  const getShiftsByService = async (idService = "") => {
    return handleRequest(() => getShifts(idService), "Error al obtener turnos");
  };

  /**
   * Actualizar turno
   */
  const updateShift = async (body = {}) => {
    return handleRequest(
      () => updateShiftsApi(body),
      "Error al actualizar turno",
    );
  };

  /**
   * Importar CSV de turnos
   */
  const importShiftUsers = async (file, service) => {
    return handleRequest(
      () => shiftScheduling(file, file?.name || "", service),
      "Error al importar turnos",
    );
  };

  return {
    createNewShift,
    getShiftsByService,
    updateShift,
    importShiftUsers,
    loader,
    error,
  };
};

export default useShifts;
